import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMap = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .3,
		d: "M10.167 21.2577L12.667 20.291V10.541L10.167 11.3827V21.2577ZM19.3337 21.4577L21.8337 20.616V10.741L19.3337 11.716V21.4577Z",
		fill: "#A750FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.0833 8.5L22.95 8.525L18.5 10.25L13.5 8.5L8.8 10.0833C8.625 10.1417 8.5 10.2917 8.5 10.4833V23.0833C8.5 23.3167 8.68333 23.5 8.91667 23.5L9.05 23.475L13.5 21.75L18.5 23.5L23.2 21.9167C23.375 21.8583 23.5 21.7083 23.5 21.5167V8.91667C23.5 8.68333 23.3167 8.5 23.0833 8.5ZM12.6667 20.2917L10.1667 21.2583V11.3833L12.6667 10.5417V20.2917ZM17.6667 21.4417L14.3333 20.275V10.5583L17.6667 11.725V21.4417ZM21.8333 20.6167L19.3333 21.4583V11.7167L21.8333 10.75V20.6167Z",
		fill: "#A750FF"
	})]
});
export default SvgMap;
